<template>
  <blank-container
    :title="$route.meta.title[$i18n.locale]"
    @addBtn="$router.push({ name: 'forms-detail' })"
  >
    <a-table
      :columns="columns"
      :data-source="list"
      bordered
      :pagination="false"
      :loading="loading"
      :row-key="(record) => record.id"
      class="forms-table__container"
    >
      <template
        v-for="col in [
          'id',
          'leader_employee_name',
          'email',
          'project_name',
          'organization_name'
        ]"
        :slot="col"
        slot-scope="text, record"
      >
        <div :key="col">
          <a-input
            v-if="record.editable"
            style="margin: -5px 0"
            :value="text"
            @change="(e) => handleChange(e.target.value, record.id, col)"
          />
          <template v-else>{{ text }}</template>
        </div>
      </template>
      <template slot="operation" slot-scope="text, record">
        <div class="editable-row-operations">
          <span v-if="record.editable">
            <a class="mr-1" @click="() => save(record.id)">Сохранить</a>
            <a-popconfirm title="Отменить?" @confirm="() => cancel(record.id)">
              <a>Отмена</a>
            </a-popconfirm>
          </span>
          <span v-else>
            <a @click="() => edit(record.id)">Правка</a>
            <a-icon
              type="edit"
              class="ml-1 action-btns"
              @click="
                $router.push({
                  name: 'forms-detail',
                  params: { id: record.id }
                })
              "
            />
            <a-popconfirm
              title="Вы действительно хотите удалить?"
              ok-text="Да"
              cancel-text="Нет"
              @confirm="deleteItemAction(record)"
            >
              <a-icon
                type="delete"
                class="action-btns"
                style="margin: 0 10px"
              />
            </a-popconfirm>
          </span>
        </div>
      </template>
    </a-table>

    <a-row v-if="count" class="mt-1">
      <a-pagination :current="page" :total="count" @change="toPage" />
    </a-row>
  </blank-container>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex"
import cloneDeep from "lodash/cloneDeep"

const columns = [
  {
    title: "ID",
    dataIndex: "id",
    width: "8%",
    scopedSlots: { customRender: "id" }
  },
  {
    title: "Ф.И.О",
    dataIndex: "leader_employee_name",
    width: "15%",
    scopedSlots: { customRender: "leader_employee_name" }
  },
  {
    title: "Почта",
    dataIndex: "email",
    width: "15%",
    scopedSlots: { customRender: "email" }
  },
  {
    title: "Проект",
    dataIndex: "project_name",
    width: "20%",
    scopedSlots: { customRender: "project_name" }
  },
  {
    title: "Организация",
    dataIndex: "organization_name",
    width: "20%",
    scopedSlots: { customRender: "organization_name" }
  },
  {
    title: "Действие",
    dataIndex: "operation",
    width: "10%",
    scopedSlots: { customRender: "operation" }
  }
]

export default {
  data() {
    return {
      columns,
      cacheData: [],
      loading: false
    }
  },

  computed: {
    ...mapState("forms", {
      list: (state) => state.list,
      count: (state) => state.count
    }),
    page() {
      return +this.$route.query.page || 1
    },
    perPage() {
      return +this.$route.query.per_page || 10
    }
  },

  watch: {
    $route: {
      handler: "fetchData",
      immediate: true
    }
  },

  methods: {
    ...mapMutations({
      removeItem: "forms/removeListItem"
    }),
    ...mapActions({
      fetch: "forms/fetch",
      deleteItemAction: "forms/deleteItemAction"
    }),
    async fetchData() {
      this.loading = true
      try {
        await this.fetch({
          page: +this.$route.query.page || 1,
          limit: +this.$route.query.per_page || 10
        })

        this.cacheData = this.list.slice()
      } catch (error) {
        console.log("fetchData", error)
      }
      this.loading = false
    },
    toPage(arg) {
      this.$router.push({ query: { ...this.$route.query, page: arg } })
    },
    copyList() {
      return cloneDeep(this.list) || []
    },
    handleChange(value, key, column) {
      // console.log('handleChange', value, key, column);
      const newData = this.copyList()
      const target = newData.filter((item) => key === item.id)[0]
      if (target) {
        target[column] = value
        this.$store.commit("forms/set", ["list", newData])
      }
    },
    edit(id) {
      // console.log('edit', id);
      this.cacheData = this.list.slice()
      const newData = this.copyList()
      const target = newData.filter((item) => id === item.id)[0]
      if (target) {
        target.editable = true
        this.$store.commit("forms/set", ["list", newData])
      }
    },
    save(id) {
      // console.log('save', id);
      const newData = this.copyList()
      const target = newData.filter((item) => id === item.id)[0]

      if (target) {
        delete target.editable
        this.$store.commit("forms/set", ["list", newData])
      }
    },
    cancel() {
      // console.log('cancel', id);
      this.$store.commit("forms/set", ["list", this.cacheData.slice()])
    }
  }
}
</script>
